import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import DropdownWithSearch from "../DropdownWithSearch";
import DropdownWithSearchOils from "../DropdownWithSearchOils";
import ConfirmationDialog from "../ConfirmationDialog";
import RegistrationFormHeading from "../../new-components/RegistrationFormHeading";
import { oilsDatabase } from "../../utils/oilsDatabase";
import { FiCheckCircle, FiTrash2, FiX } from "react-icons/fi";
import {
  deleteCampaignAppointment,
  getAppointmentDocumentId,
} from "../../services/appointmentService";
import {
  getAppointmentSelectionLabel,
  getSelectableAppointmentIds,
  toggleAllAppointmentSelection,
  toggleAppointmentSelection,
} from "../../utils/appointmentSelection";
import { resolveEventConfirmationCopy } from "../../utils/eventConfirmationCopy";


const CampaignSingle = (props) => {
  const { id: routeId } = useParams();
  const id = props.campaignId || routeId;
  const [campaignDetails, setEventsDetails] = React.useState();
  const [eventAppointments, setEventAppointments] = React.useState();
  const [highlightedText, setHighlightedText] = React.useState();
  const [splitText1, setSplitText1] = React.useState();
  const [splitText2, setSplitText2] = React.useState();
  const [userAppointment, setUserAppointment] = React.useState();
  const { user } = props.user;
  const isAdmin = Boolean(
    user?.email &&
    (user.email === process.env.REACT_APP_ADMIN ||
      user.email === process.env.REACT_APP_ARI_ADMIN)
  );
  const token = process.env.REACT_APP_TOKEN;
  const [userName, setUserName] = React.useState("");
  const [userLastname, setLastname] = React.useState("");
  const [userPhone, setUserPhone] = React.useState("");
  const [userCity, setUserCity] = React.useState("");
  const [userOils, setUserOils] = React.useState("");
  const [userNotes, setUserNotes] = React.useState({});
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [visibleAppointments, setVisibleAppointments] = React.useState(10);
  const [selectedAppointmentIds, setSelectedAppointmentIds] = React.useState(new Set());
  const [deleteDialogAppointments, setDeleteDialogAppointments] = React.useState([]);
  const [isDeletingAppointments, setIsDeletingAppointments] = React.useState(false);
  const selectAllCheckboxRef = React.useRef(null);

  const hours = Array.from({ length: 10 }, (_, i) => (i + 8).toString().padStart(2, "0")); // Ore între 08:00 și 18:00
  const minutes = ["00", "10", "20", "30", "40", "50"]; // Minute din 10 în 10
  const dates = ["Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"]; // Zilele disponibile
  const [isScheduling, setIsScheduling] = React.useState(false); // Controls whether the scheduling interface is shown
  const [isSaved, setIsSaved] = React.useState(false); // Tracks if the date and time have been saved


  const [selectedDates, setSelectedDates] = React.useState(dates[0] || "");
  const [selectedDay, setSelectedDay] = React.useState(""); // Ziua selectată

  const [isDateValid, setIsDateValid] = React.useState(true); // Stare pentru validarea datei
  const [isTimeValid, setIsTimeValid] = React.useState(true); // Stare pentru validarea orei

  const [hasTriedEssentialOils, setHasTriedEssentialOils] = React.useState(""); // Stare pentru răspunsul selectat
  const [isEssentialOilsValid, setIsEssentialOilsValid] = React.useState(true); // Stare pentru validarea răspunsului
  const [hasDoTerraAccount, setHasDoTerraAccount] = React.useState(""); // Stare pentru răspunsul selectat
  const [isDoTerraValid, setIsDoTerraValid] = React.useState(true); // Stare pentru validarea răspunsului// Adaugă o nouă stare pentru a gestiona mai multe uleiuri per utilizator

  const [userMultipleOils, setUserMultipleOils] = React.useState({});

  // Funcție pentru a adăuga un nou dropdown
  const addOilDropdown = (appointmentId) => {
    setUserMultipleOils((prev) => ({
      ...prev,
      [appointmentId]: [
        ...(prev[appointmentId] || []),
        "" // Adaugă un nou dropdown gol
      ]
    }));
  };

  // Funcție pentru a actualiza un ulei specific
  const handleMultipleOilsChange = (appointmentId, index, value) => {
    setUserMultipleOils((prev) => {
      const currentOils = prev[appointmentId] || [];
      const updatedOils = [...currentOils];
      updatedOils[index] = value;

      return {
        ...prev,
        [appointmentId]: updatedOils
      };
    });

    // Autosave pentru uleiurile multiple
    const updatedOils = [...(userMultipleOils[appointmentId] || [])];
    updatedOils[index] = value;

    handleInputChange(appointmentId, "multipleOils", updatedOils.join(", "));
  };

  const filteredAppointments = selectedDay
    ? eventAppointments?.filter((appointment) => appointment.selectedDates === selectedDay)
    : eventAppointments; // Dacă nu este selectată nicio zi, afișează toate programările

  const handleInputChange = async (appointmentId, field, value) => {
    // Actualizează starea locală
    setUserNotes((prevNotes) => ({
      ...prevNotes,
      [appointmentId]: {
        ...prevNotes[appointmentId],
        [field]: value,
      },
    }));

    // Autosave - salvează automat în baza de date
    try {
      const updatedNote = {
        ...userNotes[appointmentId],
        [field]: value,
      };

      await axios.put(
        `${process.env.REACT_APP_API_BASE}/appointment-campaign/update?id=${id}&appointmentId=${appointmentId}`,
        updatedNote,
        {
          headers: {
            Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
          },
        }
      );

      // Optional: toast pentru confirmare subtilă
      // toast.success("Salvat automat!", { autoClose: 1000 });
    } catch (error) {
      console.error("Eroare la autosave:", error);
      toast.error("Eroare la salvare automată");
    }
  };

  // Creează două funcții separate
  const handleInputChangeChallanges = (appointmentId, field, value) => {
    // Actualizează doar starea locală - fără call către API
    setUserNotes((prevNotes) => ({
      ...prevNotes,
      [appointmentId]: {
        ...prevNotes[appointmentId],
        [field]: value,
      },
    }));
  };

  // Funcție separată pentru autosave
  const handleAutosaveChallanges = async (appointmentId, field, value) => {
    try {
      const updatedNote = {
        ...userNotes[appointmentId],
        [field]: value,
      };

      await axios.put(
        `${process.env.REACT_APP_API_BASE}/appointment-campaign/update?id=${id}&appointmentId=${appointmentId}`,
        updatedNote,
        {
          headers: {
            Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
          },
        }
      );
    } catch (error) {
      console.error("Eroare la autosave:", error);
      toast.error("Eroare la salvare automată");
    }
  };

  // const saveDetails = (id) => {
  //   const userNote = userNotes[id];
  //   console.log(`Salvat pentru utilizatorul ${id}:`, userNote);
  //   // Aici poți adăuga logica pentru salvarea în baza de date
  // };


  const saveDetails = async (appointmentId) => {
    const note = userNotes[appointmentId];
    if (!note) return;

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE}/appointment-campaign/update?id=${id}&appointmentId=${appointmentId}`,
        note
      );
      toast.success("Salvat cu succes!");
    } catch (error) {
      console.error("Eroare la salvare:", error);
      toast.error("Eroare la salvare");
    }
  };

  const generateTimeSlots = () => {
    const timeSlots = [];
    for (let hour = 10; hour <= 18; hour += 2) { // Ore din 2 în 2
      const formattedHour = hour.toString().padStart(2, "0");
      timeSlots.push(`${formattedHour}:00`); // Adaugă doar ora fără minute
    }
    return timeSlots;
  };

  const getAvailableTimes = (date) => {
    if (!date || !eventAppointments) {
      return allTimeSlots; // Return all options if data is missing
    }

    // Filter appointments for the selected date
    const appointmentsForDate = eventAppointments.filter(
      (appointment) => appointment.selectedDates === date
    );

    // Get all booked times for the selected date
    const bookedTimes = appointmentsForDate.map(
      (appointment) => appointment.appointmentTime
    );

    // Filter available time slots
    const availableTimeSlots = allTimeSlots.filter(
      (timeSlot) => !bookedTimes.includes(timeSlot)
    );

    return availableTimeSlots;
  };

  const allTimeSlots = generateTimeSlots(); // Generate all time slots

  const fetchEventData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/campaign/id/get?id=${id}`
    );
    setEventsDetails(result.data);
    filterText(result.data.text);
  };

  const fetchAppointmentsData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/appointment-campaign/get?id=${id}`
    );
    const appointments = result.data;
    setEventAppointments(appointments);

    // Pregătește datele pentru inputuri
    const initialNotes = {};
    const initialMultipleOils = {};

    appointments.forEach((appointment) => {
      // Verifică dacă utilizatorul are deja date salvate în baza de date
      const hasExistingData = appointment.provocari || appointment.mostre || appointment.multipleOils;

      if (hasExistingData) {
        // Utilizator existent - încarcă datele existente
        initialNotes[appointment.id] = {
          provocari: appointment.provocari || "",
          mostre: appointment.mostre || "",
        };

        // Deserializează uleiurile multiple din string în array DOAR pentru utilizatorii existenți
        if (appointment.multipleOils) {
          const oilsArray = appointment.multipleOils.split(", ").filter(oil => oil.trim() !== "");
          initialMultipleOils[appointment.id] = oilsArray;
        }
      } else {
        // Utilizator nou - setează valori goale (nule)
        initialNotes[appointment.id] = {
          provocari: "",
          mostre: "",
        };
        // Pentru utilizatorii noi, nu inițializa uleiurile multiple
        // Butonul "Adaugă" va fi vizibil, dar fără dropdown-uri inițiale
      }
    });

    setUserNotes(initialNotes);
    setUserMultipleOils(initialMultipleOils); // Conține doar utilizatorii existenți cu uleiuri
  };

  const requestDeleteAppointments = (appointments) => {
    const validAppointments = (appointments || []).filter(getAppointmentDocumentId);
    if (!validAppointments.length) {
      toast.error("Înscrierea nu are un identificator valid.");
      return;
    }

    setDeleteDialogAppointments(validAppointments);
  };

  const confirmDeleteAppointments = async () => {
    if (!deleteDialogAppointments.length) return;

    setIsDeletingAppointments(true);
    const results = await Promise.allSettled(
      deleteDialogAppointments.map((appointment) =>
        deleteCampaignAppointment(id, getAppointmentDocumentId(appointment))
      )
    );
    const deletedAppointments = deleteDialogAppointments.filter((appointment, index) =>
      results[index].status === "fulfilled"
    );
    const deletedIds = new Set(deletedAppointments.map(getAppointmentDocumentId));

    if (deletedIds.size) {
      setEventAppointments((current) =>
        (current || []).filter((item) => !deletedIds.has(getAppointmentDocumentId(item)))
      );
      setEventsDetails((current) => current
        ? {
          ...current,
          appointments: Math.max(0, Number(current.appointments || 0) - deletedIds.size),
        }
        : current
      );
      setUserNotes((current) => {
        const next = { ...current };
        deletedAppointments.forEach((appointment) => delete next[appointment.id]);
        return next;
      });
      setUserMultipleOils((current) => {
        const next = { ...current };
        deletedAppointments.forEach((appointment) => delete next[appointment.id]);
        return next;
      });
      setSelectedAppointmentIds((current) => {
        const next = new Set(current);
        deletedIds.forEach((appointmentId) => next.delete(appointmentId));
        return next;
      });
    }

    // const failedCount = results.length - deletedIds.size;
    // if (deletedIds.size) {
    //   toast.success(deletedIds.size === 1
    //     ? "Înscrierea la mostre a fost ștearsă."
    //     : `${deletedIds.size} înscrieri la mostre au fost șterse.`
    //   );
    // }
    // if (failedCount) {
    //   toast.error(failedCount === 1
    //     ? "O înscriere nu a putut fi ștearsă."
    //     : `${failedCount} înscrieri nu au putut fi șterse.`
    //   );
    // }

    setIsDeletingAppointments(false);
    setDeleteDialogAppointments([]);
  };


  React.useEffect(() => {
    fetchEventData();
    fetchAppointmentsData();
  }, []);

  const updateEventAppointments = async (id) => {
    const eventData = {
      appointments: (eventAppointments?.length || 0) + 1,
    };

    await axios.put(
      `${process.env.REACT_APP_API_BASE}/campaign/put?id=${id}`,
      eventData,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
        },
      }
    );
  };
  const postAppointment = async (e) => {
    // e.preventDefault();

    // let isValid = true;

    // if (!selectedDates) {
    //   setIsDateValid(false); // Marchează câmpul de dată ca invalid
    //   isValid = false;
    // } else {
    //   setIsDateValid(true); // Resetează validarea pentru dată
    // }

    // if (!userAppointment) {
    //   setIsTimeValid(false); // Marchează câmpul de oră ca invalid
    //   isValid = false;
    // } else {
    //   setIsTimeValid(true); // Resetează validarea pentru oră
    // }

    // if (!isValid) {
    //   return; // Oprește trimiterea formularului dacă există erori
    // }

    e.preventDefault();

    let isValid = true;

    if (!userName.trim() || !userLastname.trim() || !userPhone.trim() || !userCity) {
      toast.warning("Completează toate datele de contact.");
      isValid = false;
    }

    if (!hasDoTerraAccount) {
      setIsDoTerraValid(false); // Marchează întrebarea ca invalidă
      isValid = false;
    } else {
      setIsDoTerraValid(true); // Resetează validarea
    }

    if (!hasTriedEssentialOils) {
      setIsEssentialOilsValid(false); // Marchează întrebarea ca invalidă
      isValid = false;
    } else {
      setIsEssentialOilsValid(true); // Resetează validarea
    }

    if (!isValid) {
      return; // Oprește trimiterea formularului dacă există erori
    }

    try {
      setIsSubmitting(true);
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/appointment-campaign/post?id=${id}`,
        {
          id: Date.now(),
          createDate: Date.now(),
          name: userName,
          lastname: userLastname,
          phone: userPhone,
          city: userCity,
          appointmentTime: userAppointment,
          // selectedDates: selectedDates,
          hasDoTerraAccount: hasDoTerraAccount,
          hasTriedEssentialOils: hasTriedEssentialOils,
        }
      );

      // Afișează mesajul elegant de succes
      setShowSuccessMessage(true);

      updateEventAppointments(id);
      fetchAppointmentsData();
      resetFormFields();

    } catch (error) {
      console.error(error);
      toast.warning("Nu a fost trimis");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetFormFields = () => {
    setUserName("");
    setLastname("");
    setUserPhone("");
    setUserCity("");
    setUserAppointment("");
    setSelectedDates(dates[0] || "");
    setHasDoTerraAccount("");
    setHasTriedEssentialOils("");
  };

  const groupTimeSlots = (timeSlots) => {
    const grouped = [];
    for (let i = 0; i < timeSlots.length; i += 6) {
      grouped.push(timeSlots.slice(i, i + 6)); // Group by 6 (e.g., 8:00 to 8:50)
    }
    return grouped;
  };

  const groupedTimeSlots = groupTimeSlots(getAvailableTimes(selectedDates));

  const groupAvailableTimeSlotsByHour = (timeSlots, bookedTimes) => {
    const grouped = {};
    timeSlots.forEach((timeSlot) => {
      const [hour, minute] = timeSlot.split(":");
      if (!bookedTimes.includes(timeSlot)) {
        if (!grouped[hour]) {
          grouped[hour] = [];
        }
        grouped[hour].push(minute);
      }
    });

    // Remove hours with no available minutes
    Object.keys(grouped).forEach((hour) => {
      if (grouped[hour].length === 0) {
        delete grouped[hour];
      }
    });

    return grouped;
  };

  const groupedAvailableTimeSlots = groupAvailableTimeSlotsByHour(
    generateTimeSlots(),
    eventAppointments
      ?.filter((appointment) => appointment.selectedDates === selectedDates)
      .map((appointment) => appointment.appointmentTime) || []
  );

  const getAvailableTimeSlots = (date) => {
    if (!date || !eventAppointments) {
      return groupAvailableTimeSlotsByHour(allTimeSlots, []); // Return all options if no data
    }

    // Filter appointments for the selected date
    const appointmentsForDate = eventAppointments.filter(
      (appointment) => appointment.selectedDates === date
    );

    // Get all booked times for the selected date
    const bookedTimes = appointmentsForDate.map(
      (appointment) => appointment.appointmentTime
    );

    // Group available time slots by hour
    return groupAvailableTimeSlotsByHour(allTimeSlots, bookedTimes);
  };

  // const groupedAvailableTimeSlots = getAvailableTimeSlots(selectedDates);

  const returnDate = (date) => {
    const newDate = new Date(date);
    const formatDate = moment(newDate).format("MMMM Do YYYY");
    return formatDate;
  };

  const filterText = (text) => {
    const highlightedTextStart = text.indexOf("/*");
    const highlightedTextStop = text.indexOf("*/");
    if (
      highlightedTextStart > -1 &&
      highlightedTextStop > -1 &&
      highlightedTextStop > highlightedTextStart
    ) {
      const getText = text.substring(
        highlightedTextStart + 2,
        highlightedTextStop
      );
      setHighlightedText(getText);
      getRemainingText(text, highlightedTextStart, highlightedTextStop);
    } else {
      setSplitText1(text);
    }
  };

  const getRemainingText = (
    text,
    highlightedTextStart,
    highlightedTextStop
  ) => {
    if (highlightedTextStart === 0) {
      const splitText = text.substring(highlightedTextStop + 2, text.length);
      setSplitText2(splitText);
    }
    if (highlightedTextStart > 0) {
      const splitText1 = text.substring(0, highlightedTextStart);
      setSplitText1(splitText1);
      const splitText2 = text.substring(highlightedTextStop + 2, text.length);
      setSplitText2(splitText2);
    }
    if (highlightedTextStop + 2 === text.length) {
      const splitText1 = text.substring(0, highlightedTextStart);
      setSplitText1(splitText1);
    }
  };

  const visibleCampaignAppointments = React.useMemo(() =>
    (filteredAppointments || [])
      .slice()
      .sort((a, b) => new Date(b.createDate) - new Date(a.createDate))
      .slice(0, visibleAppointments),
    [filteredAppointments, visibleAppointments]
  );
  const visibleAppointmentIds = getSelectableAppointmentIds(visibleCampaignAppointments);
  const allVisibleAppointmentsSelected = visibleAppointmentIds.length > 0
    && visibleAppointmentIds.every((appointmentId) => selectedAppointmentIds.has(appointmentId));
  const someVisibleAppointmentsSelected = visibleAppointmentIds.some((appointmentId) =>
    selectedAppointmentIds.has(appointmentId)
  );

  React.useEffect(() => {
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = someVisibleAppointmentsSelected
        && !allVisibleAppointmentsSelected;
    }
  }, [allVisibleAppointmentsSelected, someVisibleAppointmentsSelected]);

  const selectedAppointments = (eventAppointments || []).filter((appointment) =>
    selectedAppointmentIds.has(getAppointmentDocumentId(appointment))
  );
  const confirmationCopy = resolveEventConfirmationCopy(campaignDetails);

  return (
    <section className={`wpo-event-single-section section-padding ${
      isAdmin ? "" : "samples-registration-content--public"
    }`}>
      <ConfirmationDialog
        open={deleteDialogAppointments.length > 0}
        title={deleteDialogAppointments.length > 1
          ? `Ștergi ${deleteDialogAppointments.length} înscrieri?`
          : "Ștergi această înscriere?"
        }
        description="Această acțiune elimină definitiv înregistrarea din tabel și nu poate fi anulată."
        confirmLabel={deleteDialogAppointments.length > 1 ? "Șterge selecția" : "Șterge înscrierea"}
        isConfirming={isDeletingAppointments}
        onConfirm={confirmDeleteAppointments}
        onCancel={() => setDeleteDialogAppointments([])}
      />
      {/* Mesaj de succes elegant */}
      {showSuccessMessage && (
        <div className="registration-success" role="dialog" aria-modal="true" aria-labelledby="samples-confirmation-title">
          <div className="registration-success__dialog">
            <button
              type="button"
              className="registration-success__close"
              aria-label="Închide confirmarea"
              onClick={() => setShowSuccessMessage(false)}
            >
              <FiX aria-hidden="true" />
            </button>
            <FiCheckCircle className="registration-success__icon" aria-hidden="true" />
            <span className="registration-success__eyebrow">{confirmationCopy.pretitle}</span>
            <h2 id="samples-confirmation-title">{confirmationCopy.title}</h2>
            <p>{confirmationCopy.text}</p>
            <button type="button" className="registration-success__action" onClick={() => setShowSuccessMessage(false)}>
              Am înțeles
            </button>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-event-content">
              <div className="post format-standard-image">
                {/* <h2>{campaignDetails?.title}</h2> */}
                <div className="event-media">
                  {campaignDetails && (
                    <img
                      src={campaignDetails.coverImage}
                      alt={campaignDetails.title || "Imaginea campaniei de mostre"}
                      className="styled-image" draggable="false"
                      loading="lazy"
                      decoding="async"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-event-content">
              {isAdmin ? (
                <div className="appointments-area">
                  <div className="appointments-section">
                    <h3 className="appointments-title">Toate înscrierile</h3>

                    <div className="appointment-selection-toolbar">
                      <button
                        type="button"
                        className="appointment-bulk-delete-button"
                        onClick={() => requestDeleteAppointments(selectedAppointments)}
                        disabled={!selectedAppointments.length || isDeletingAppointments}
                      >
                        <FiTrash2 aria-hidden="true" />
                        Șterge
                      </button>
                      {selectedAppointmentIds.size > 0 && (
                        <span aria-live="polite">
                          {getAppointmentSelectionLabel(selectedAppointmentIds.size)}
                        </span>
                      )}
                    </div>

                    <ol className="appointments">
                      <li className="appointment">
                        <table className="appointment-table">
                          <thead>
                            <tr>
                              <th className="col-select">
                                <input
                                  ref={selectAllCheckboxRef}
                                  type="checkbox"
                                  checked={allVisibleAppointmentsSelected}
                                  onChange={() => setSelectedAppointmentIds((current) =>
                                    toggleAllAppointmentSelection(current, visibleCampaignAppointments)
                                  )}
                                  aria-label="Selectează toate înscrierile afișate"
                                />
                              </th>
                              <th className="col-name">Nume</th>
                              <th className="col-lastname">Prenume</th>
                              <th className="col-phone">Telefon</th>
                              <th className="col-city">Oraş</th>
                              <th className="col-tried-oils">Încercat</th>
                              <th className="col-doterra">Cont</th>
                              <th className="col-challenges">Provocări</th>
                              <th className="col-samples">Mostre</th>
                              <th className="col-actions">Acțiuni</th>
                            </tr>
                          </thead>
                          <tbody>
                            {visibleCampaignAppointments.map((appointment, index) => {
                                const appointmentId = getAppointmentDocumentId(appointment);
                                const isDeleting = isDeletingAppointments
                                  && deleteDialogAppointments.some((item) =>
                                    getAppointmentDocumentId(item) === appointmentId
                                  );
                                return (
                                <tr key={appointmentId || index} className={selectedAppointmentIds.has(appointmentId) ? "is-selected" : ""}>
                                  <td className="col-select">
                                    <input
                                      type="checkbox"
                                      checked={selectedAppointmentIds.has(appointmentId)}
                                      onChange={() => setSelectedAppointmentIds((current) =>
                                        toggleAppointmentSelection(current, appointmentId)
                                      )}
                                      aria-label={`Selectează înscrierea pentru ${appointment.name || "utilizator"} ${appointment.lastname || ""}`.trim()}
                                      disabled={!appointmentId || isDeletingAppointments}
                                    />
                                  </td>
                                  <td className="col-name">{appointment.name}</td>
                                  <td className="col-lastname">{appointment.lastname}</td>
                                  <td className="col-phone">{appointment.phone}</td>
                                  <td className="col-city">{appointment.city}</td>
                                  <td className="col-tried-oils">{appointment.hasTriedEssentialOils}</td>
                                  <td className="col-doterra">{appointment.hasDoTerraAccount}</td>
                                  <td className="col-challenges">
                                    <textarea
                                      className={`minimal-input ${userNotes[appointment.id]?.provocari ? "expanded" : ""}`}
                                      value={userNotes[appointment.id]?.provocari || ""}
                                      onFocus={(e) => e.target.classList.add("expanded")}
                                      onBlur={(e) => {
                                        if (!e.target.value) {
                                          e.target.classList.remove("expanded");
                                        } handleAutosaveChallanges(appointment.id, "provocari", e.target.value);
                                      }}
                                      onChange={(e) =>
                                        handleInputChangeChallanges(appointment.id, "provocari", e.target.value)
                                      } />
                                  </td>
                                  <td className="col-samples">
                                    <div>
                                      <DropdownWithSearchOils
                                        options={oilsDatabase}
                                        userOils={userNotes[appointment.id]?.mostre || ""}
                                        setUserOils={(selectedOption) => {
                                          handleInputChange(appointment.id, "mostre", selectedOption);
                                        }}
                                        placeholder="Selectează uleiul"
                                      />

                                      {(userMultipleOils[appointment.id] || []).map((oil, index) => (
                                        <div key={index} style={{ marginTop: "5px" }}>
                                          <DropdownWithSearchOils
                                            options={oilsDatabase}
                                            userOils={oil}
                                            setUserOils={(selectedOption) => {
                                              handleMultipleOilsChange(appointment.id, index, selectedOption);
                                            }}
                                            placeholder={`Ulei ${index + 2}`}
                                          />
                                        </div>
                                      ))}

                                      <button
                                        className="add-oil-button"
                                        onClick={() => addOilDropdown(appointment.id)}
                                        style={{
                                          marginTop: "5px",
                                          padding: "4px 8px",
                                          fontSize: "10px",
                                          backgroundColor: "#904d71",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "4px",
                                          cursor: "pointer"
                                        }}
                                      >
                                        Adaugă
                                      </button>
                                    </div>
                                  </td>
                                  <td className="col-actions">
                                    <button
                                      type="button"
                                      className="appointment-delete-button"
                                      onClick={() => requestDeleteAppointments([appointment])}
                                      disabled={isDeletingAppointments || !appointmentId}
                                      aria-label={`Șterge înscrierea pentru ${appointment.name || "utilizator"} ${appointment.lastname || ""}`.trim()}
                                    >
                                      <FiTrash2 aria-hidden="true" />
                                      {isDeleting ? "Se șterge…" : "Șterge"}
                                    </button>
                                  </td>
                                </tr>
                              );})}
                          </tbody>
                        </table>
                      </li>
                    </ol>
                    <div className="samples-table-footer">
                      <span>
                        Se afișează {Math.min(visibleAppointments, filteredAppointments?.length || 0)} din {filteredAppointments?.length || 0} înscrieri
                      </span>
                      {visibleAppointments < (filteredAppointments?.length || 0) && (
                        <button
                          type="button"
                          className="samples-load-more"
                          onClick={() => setVisibleAppointments((current) => current + 10)}
                        >
                          Încarcă mai multe ({Math.min(10, filteredAppointments.length - visibleAppointments)})
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form-submit">

                </div>
              )}
              <section className="wpo-appointment-pg-section section-padding-small">
                <div
                  className="wpo-appointment-form-area"
                  style={{ marginBottom: "-100px" }}
                >
                  <div className="appointments-area">
                    <div className="appointment-respond">
                      <RegistrationFormHeading />
                      <p className="appointment-form-kicker">
                        Completează datele de contact și răspunde la cele două întrebări de eligibilitate.
                      </p>

                      <form
                        onSubmit={postAppointment}
                        id="appointmentform"
                        className="appointment-form"
                      >
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="name">Nume</label>
                              <input
                                type="text"
                                id="name"
                                placeholder="Nume"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="lastname">Prenume</label>
                              <input
                                type="text"
                                id="lastname"
                                placeholder="Prenume"
                                value={userLastname}
                                onChange={(e) => setLastname(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="phone">Telefon</label>
                              <input
                                type="tel"
                                id="phone"
                                placeholder="Telefon"
                                value={userPhone}
                                onChange={(e) => setUserPhone(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label>Județ</label>
                              <DropdownWithSearch userCity={userCity} setUserCity={setUserCity} />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label className="form-label">Ai încercat uleiurile esențiale?</label>
                              <div className="button-group">
                                <button
                                  type="button"
                                  className={`option-button ${hasTriedEssentialOils === "Da" ? "active" : ""}`}
                                  onClick={() => setHasTriedEssentialOils("Da")}
                                >
                                  Da
                                </button>
                                <button
                                  type="button"
                                  className={`option-button ${hasTriedEssentialOils === "Nu" ? "active" : ""}`}
                                  onClick={() => setHasTriedEssentialOils("Nu")}
                                >
                                  Nu
                                </button>
                              </div>
                              {!isEssentialOilsValid && (
                                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                  Te rugăm să selectezi un răspuns!
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label className="form-label">Ai cont doTERRA?</label>
                              <div className="button-group">
                                <button
                                  type="button"
                                  className={`option-button ${hasDoTerraAccount === "Da" ? "active" : ""}`}
                                  onClick={() => setHasDoTerraAccount("Da")}
                                >
                                  Da
                                </button>
                                <button
                                  type="button"
                                  className={`option-button ${hasDoTerraAccount === "Nu" ? "active" : ""}`}
                                  onClick={() => setHasDoTerraAccount("Nu")}
                                >
                                  Nu
                                </button>
                              </div>
                              {!isDoTerraValid && (
                                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                  Te rugăm să selectezi un răspuns!
                                </p>
                              )}
                            </div>
                          </div>
                          {/* <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              {!isScheduling && (
                                <button
                                  className="schedule-button"
                                  style={{ paddingTop: "10px" }}
                                  onClick={() => {
                                    setIsScheduling(true);
                                  }}
                                >
                                  {isSaved ? "Schimbă programarea" : "Programează-te"}
                                </button>

                              )}
                            </div>
                            {isScheduling && (
                              <div>
                                <label htmlFor="hour">Selectează ziua și ora: </label>
                               
                                <div className="date-options">
                                  {dates.map((date, index) => (
                                    <button
                                      key={index}
                                      className={`date-option-button ${selectedDates === date ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.preventDefault(); 
                                        setSelectedDates(date); 
                                        setIsDateValid(true);
                                      }}
                                    >
                                      {date}
                                    </button>
                                  ))}
                                </div>
                                {!isDateValid && (
                                  <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                    Te rugăm să selectezi o zi!
                                  </p>
                                )}
                                
                                <div className="time-slots-container">
                                  {Object.entries(groupedAvailableTimeSlots)
                                    .sort(([hourA], [hourB]) => parseInt(hourA) - parseInt(hourB))
                                    .map(([hour, availableMinutes], index) => (
                                      availableMinutes.map((minute) => (
                                        <button
                                          key={`${hour}:${minute}`}
                                          className={`time-slot-button ${userAppointment === `${hour}:${minute}` ? "active" : ""}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setUserAppointment(`${hour}:${minute}`);
                                            setIsTimeValid(true); 
                                          }}
                                        >
                                          {hour}:{minute}
                                        </button>
                                      ))
                                    ))}
                                </div>
                                <button
                                  className="save-button"
                                  onClick={() => {
                                    setIsScheduling(false); 
                                    setIsSaved(true); 
                                  }}
                                >
                                  Salvează
                                </button>
                              </div>
                            )}
                          </div>
                          {!isTimeValid && (
                                  <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                    Te rugăm să selectezi o oră!
                                  </p>
                                )} */}
                        </div>
                        <div className="form-submit">
                          <input
                            id="submit"
                            className="submit-button"
                            value={isSubmitting ? "Se trimite…" : "Trimite"}
                            type="submit"
                            disabled={isSubmitting}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <section className={`wpo-about-section section-padding ${props.pt}`} style={{ paddingTop: '140px', paddingBottom: '0px' }}>
              {/* <div className="container" style={{ paddingTop: '20px' }}> */}
              {/* <div className="wpo-about-section-wrapper" >
                <div className="row align-items-center">
                  <div className="col-md-12 col-12">
                    <div className="wpo-about-content">
                      <div className="wpo-about-content-inner">
                        <section>
                          <p
                            style={{
                              fontSize: '14px', // Adjust the font size as needed
                              lineHeight: '1.5',
                            }}
                          >
                            *daca ești din Sibiu, îți voi livra personal pachetul.
                            <br />
                            **pentru cei din afara orașului Sibiu, pachetul se va trimite prin curier, transportul se va achita de beneficiar la primirea coletului.
                          </p>

                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* </div> */}
            </section>
          </div>
          {/* <BlogSidebar blLeft={props.blLeft} /> */}
        </div>
      </div >
    </section >
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(CampaignSingle);
